import React, { useEffect } from "react";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import { gpColors } from "../../constants/colors";
import {
  Button,
  makeStyles,
  Link,
  Box,
  Container,
  TextField,
  Snackbar,
  IconButton,
} from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "30px",
    fontSize: "14.5px",
    marginTop: "75px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "105px",
    },
  },
  aboutContainer: {
    padding: "15px",
    fontSize: "14.5px",
  },
  heading: {
    fontWeight: 900,
    fontSize: "20px",
    height: "53px",
    background: "#36404b",
    margin: "0px",
    lineHeight: "58px",
    letterSpacing: "1px",
    textAlign: "center",
    color: "#fff",
    position: "relative",
    width: "260px",
    marginBottom: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:before": {
      content: "''",

      left: "-20px",
      borderStyle: "solid",
      borderWidth: "0 0 53px 20px",
      borderColor: `transparent transparent ${gpColors.logoBrown} transparent`,
      position: "absolute",
    },
    "&:after": {
      content: "''",
      right: "-20px",
      borderStyle: "solid",
      borderWidth: "53px 20px 0 0",
      borderColor: `${gpColors.logoBrown} transparent transparent transparent`,
      position: "absolute",
    },
  },
  content: {
    fontSize: "14.5px",
    fontWeight: 600,
    lineHeight: 2,
  },
  textFieldStyle: {
    width: "100%",
    [theme.breakpoints.only("xs")]: {
      width: "115%",
    },
    "& label.Mui-focused": {
      color: "Blue",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "Blue",
      },
      "&:hover fieldset": {
        borderColor: "Blue",
      },
    },
  },
}));

function Contact() {
  const classes = useStyles();
  useEffect(() => {
    // console.log('rendered')
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const [contactDetails, setContactDetails] = useState({
    name: "",
    phone_number: "",
    emailId: "",
    message: "",
  });

  const [error, setError] = useState({
    name: "",
    phone_number: "",
    emailId: "",
    message: "",
  });

  function handleChange(e) {
    let value = e.target.value;
    let name = e.target.name;

    setContactDetails({ ...contactDetails, [name]: value });
    setError({ ...error, [name]: "" });
  }

  function submitContactDetails(e) {
    e.preventDefault();
    if (
      contactDetails.name.length === 0 &&
      contactDetails.phone_number.length === 0 &&
      contactDetails.emailId.length === 0 &&
      contactDetails.message.length === 0
    ) {
      setError({
        ...error,
        name: "Please enter name.",
        phone_number: "Please enter phone number.",
        emailId: "Please enter email ID",
        message: "Please enter message.",
      });
    } else if (contactDetails.name.length === 0) {
      setError({
        ...error,
        name: "Please enter name.",
      });
      if (contactDetails.phone_number.length === 0) {
        setError({
          ...error,
          name: "Please enter name.",
          phone_number: "Please enter phone number",
        });
        if (contactDetails.message.length === 0) {
          setError({
            ...error,
            name: "Please enter name.",
            phone_number: "Please enter phone no.",
            message: "Please enter messsage.",
          });
        } else if (contactDetails.emailId.length === 0) {
          setError({
            ...error,
            name: "Please enter name.",
            phone_number: "Please enter phone no.",
            emailId: "Please enter email ID.",
          });
        }
      } else if (contactDetails.emailId.length === 0) {
        setError({
          ...error,
          name: "Please enter name.",
          emailId: "Please enter email ID.",
        });
        if (contactDetails.message.length === 0) {
          setError({
            ...error,
            name: "Please enter name.",
            emailId: "Please enter email ID.",
            message: "Please enter message.",
          });
        }
      } else if (contactDetails.message.length === 0) {
        setError({
          ...error,
          name: "Please enter name.",
          message: "Please enter message.",
        });
      }
    } else if (contactDetails.phone_number.length === 0) {
      setError({
        ...error,
        phone_number: "Please enter phone number",
      });
      if (contactDetails.emailId.length === 0) {
        setError({
          ...error,
          phone_number: "Please enter phone number",
          emailId: "Please enter email ID.",
        });
        if (contactDetails.message.length === 0) {
          setError({
            ...error,
            phone_number: "Please enter phone number",
            emailId: "Please enter email ID.",
            message: "Please enter message.",
          });
        }
      } else if (contactDetails.message.length === 0) {
        setError({
          ...error,
          phone_number: "Please enter phone number",
          message: "Please enter message.",
        });
      }
    } else if (contactDetails.emailId.length === 0) {
      setError({
        ...error,
        emailId: "Please enter email ID.",
      });
      if (contactDetails.message.length === 0) {
        setError({
          ...error,
          emailId: "Please enter email ID.",
          message: "Please enter message.",
        });
      }
    } else if (contactDetails.message.length === 0) {
      setError({
        ...error,
        message: "Please enter message.",
      });
    } else if (contactDetails.phone_number.match(/^[0-9]+$/) === null) {
      // check phone number have only numbers or not
      setError({
        ...error,
        phone_number: "Phone number must be have only numbers.",
      });
    } else if (
      contactDetails.emailId.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      ) === null
    ) {
      // check email id is valid or not
      setError({
        ...error,
        emailId: "Please enter valid Email ID.",
      });
    } else {
      //when all validations are done then API call for send email
      fetch(`${process.env.REACT_APP_API_ENDPOINT}/send-mail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // // "ngrok-skip-browser-warning": "true",
        },
        body: JSON.stringify(contactDetails),
      })
        .then((response) => response.json())
        .then((json) => {
          console.log("Status", json);
          if (json.hasOwnProperty("status")) {
            if (json.status === "Mail Sent Successfully") {
              // after successfully submitted form show success message
              setSuccessSubmit(true);
            }
          }
        });
      setContactDetails({
        ...contactDetails,
        name: "",
        phone_number: "",
        emailId: "",
        message: "",
      });
    }
  }

  const [successSubmit, setSuccessSubmit] = useState(false);
  const handleCloseSuccess = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessSubmit(false);
  };

  return (
    <div>
      <Header />
      <Container>
        <div className={classes.container}>
          <div
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className={classes.heading}>Contact</div>
          </div>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              textAlign: "justify",
              fontSize: "16px",
            }}
          >
            <Box padding={2} sx={{ width: { md: "100%", sm: "50%" } }}>
              <Link color="inherit" href="mailto:sales@gpautocomp.com">
                sales@gpautocomp.com
              </Link>
              <Box style={{ marginBottom: "20px" }}>+91 9979842040</Box>
              <Box>
                Address: Plot No 1108, Phase – II, GIDC, Chhatral, Tal Kalol,
                Dist Gandhinagar – 382729.
              </Box>
            </Box>
            <Box padding={2} sx={{ width: { md: "100%", sm: "50%" } }}>
              <form>
                <Box marginBottom={2}>
                  <TextField
                    className={classes.textFieldStyle}
                    label="Name*"
                    variant="outlined"
                    size="small"
                    name="name"
                    value={contactDetails.name}
                    onChange={(e) => handleChange(e)}
                    error={error.name ? true : false}
                    helperText={error.name}
                  />
                </Box>
                <Box marginBottom={2}>
                  <TextField
                    className={classes.textFieldStyle}
                    label="Phone Number*"
                    variant="outlined"
                    size="small"
                    name="phone_number"
                    value={contactDetails.phone_number}
                    onChange={(e) => handleChange(e)}
                    error={error.phone_number ? true : false}
                    helperText={error.phone_number}
                  />
                </Box>
                <Box marginBottom={2}>
                  <TextField
                    className={classes.textFieldStyle}
                    label="Email*"
                    variant="outlined"
                    size="small"
                    name="emailId"
                    type="email"
                    value={contactDetails.emailId}
                    onChange={(e) => handleChange(e)}
                    error={error.emailId ? true : false}
                    helperText={error.emailId}
                  />
                </Box>
                <Box marginBottom={2}>
                  <TextField
                    className={classes.textFieldStyle}
                    label="Message*"
                    variant="outlined"
                    size="small"
                    multiline
                    rows={3}
                    name="message"
                    value={contactDetails.message}
                    onChange={(e) => handleChange(e)}
                    error={error.message ? true : false}
                    helperText={error.message}
                  />
                </Box>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  endIcon={<SendIcon />}
                  onClick={(e) => submitContactDetails(e)}
                >
                  Send
                </Button>
              </form>
            </Box>
          </Box>
        </div>
      </Container>

      {/* after successfully submitted form show success message */}
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        ContentProps={{
          style: { background: "green" },
        }}
        open={successSubmit}
        autoHideDuration={5000}
        onClose={handleCloseSuccess}
        message="Your form has been submitted successfully!"
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleCloseSuccess}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
      <Footer />
    </div>
  );
}

export default Contact;
